module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-70x70-fc71dc75c605eee4b8f5c07fb2601f01.png";